<template>
  <div id="demo-basic-card">
    <div class="card-view " >
      <div class="vx-row w-full ">
        <div class="vx-col md:w-1/2 w-full mb-2 mt-2">
          <span class="ml-6 title-page" @click="backTrending">{{$t('managermentTrending.contentTrending')}}</span>
          <label class="text-font ml-6">{{$t('managermentTrending.TrendingsMentionInSocial')}}</label>
        </div>
        <div class="vx-row w-full md:w-1/2 pr-8" style="display: flex;justify-content: flex-end;align-items: center;">
          <div class="ml-8 mt-4" style = "text-align: right;float:right;">
            <span class="text-size">{{$t('title.time')}}: </span>
            <date-range-picker
              class="ml-2"
              ref="picker"
              :locale-data="{format: 'dd/mm/yyyy' }"
              :opens="'left'"
              @update="initScreen"
              v-model="dateRange">
            </date-range-picker>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row w-full ml-0">
      <div class="card-view-xhh md:w-2/12 w-full">
        <h4 class="w-full title">{{$t('managerKeyword.keyword')}}</h4>
        <div class="ml-4 mt-5">
          <vx-tooltip
          :text="this.resultData[0].topicName"
          color="warning">
            <div @mousemove="styleTooltip" class="name-trending" title="Từ khóa" v-if="topicDisplay">{{this.resultData[0].topicName}}</div>
          </vx-tooltip>
        </div>
      </div>
      <div class="card-view-xhh vx-col md:w-10/12 w-full">
        <h4 class="w-full title">{{$t('managermentTrending.totalInteractiveContent')}}</h4>
        <div class="vx-col w-full md:w-1/4 ">
          <h1 class="mt-5 ml-10" style="color: #277df6">{{ totalMentioned.toLocaleString() }}</h1>
          <p class="mt-1 ml-10">{{$t('managermentTrending.totalNumber')}}</p>
        </div>
        <div class="vx-col w-full md:w-1/4 ">
          <h1 class="mt-5 ml-10" style="color: #277df6">{{totalPost.toLocaleString()}}</h1>
          <p class="mt-1 ml-10">{{$t('managermentTrending.post')}}</p>
        </div>
        <div class="vx-col w-full md:w-1/4 ">
          <h1 class="mt-5 ml-10" style="color: #277df6">{{ totalDiscuss.toLocaleString() }}</h1>
          <p class="mt-1 ml-10">{{$t('articleBookmark.comment')}}</p>
        </div>
        <div class="vx-col w-full md:w-1/4 ">
          <h1 class="mt-5 ml-10" style="color: #277df6">{{sharePost.toLocaleString()}}</h1>
          <p class="mt-1 ml-10">{{$t('managermentTrending.interactive')}}</p>
        </div>
      </div>
    </div>
    <div class="card-view-xhh">
      <div class="vx-row">
        <div class="vx-col w-full mt-2">
          <h4 style="color: #626262;">{{$t('managermentTrending.titleChart')}}<div v-if="!showWorkChart" class="lds-facebook"><div></div><div></div><div></div></div></h4>
          <div class="vx-row mt-5">
            <div class="vx-col w-full">
              <vue-apex-charts
                v-if="showWorkChart"
                type=line
                height="266"
                :options="salesLine.chartOptions"
                :series="salesLine.series"
                aria-valuemax="18"
                aria-valuemin="9n"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row ml-0">
      <div class="md:w-1/2 vx-col w-full">
        <div class="card-view-xhh">
          <vs-table stripe  :data="listWebTop" :noDataText="this.$t('noData')">
            <template slot="header">
              <h3 class="mb-2">
                {{$t('managermentTrending.titleTable')}}
                <div v-if="!showWebsite" class="lds-facebook"><div></div><div></div><div></div></div>
              </h3>
            </template>
            <template slot="thead">
              <th>{{$t('managermentTrending.webName')}}</th>
              <th>{{$t('managermentTrending.interactionOccupies')}}</th>
              <th>{{$t('managermentTrending.posts')}}</th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td>
                  <a target="_blank" :href=data[indextr].link style="color: #626262 !important;display:flex;"><feather-icon icon="ChromeIcon" style="width: 1.5rem;height: 1.5rem;"></feather-icon><span class="ml-2">{{data[indextr].name}}</span></a>
                </vs-td>
                <vs-td >
                  <span class="pl-6">{{data[indextr].percent}}%</span>
                </vs-td>
                <vs-td >
                  <span class="pl-6">{{data[indextr].post}}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
      <div class="md:w-1/2 vx-col w-full">
        <div class="card-view-xhh">
          <vs-table stripe  :data="topFacebook" :noDataText="this.$t('noData')">
            <template slot="header">
              <h3 class="mb-2">
                {{$t('managermentTrending.titleTableFace')}}
                <div v-if="!showFacebook" class="lds-facebook"><div></div><div></div><div></div></div>
              </h3>
            </template>
            <template slot="thead">
              <th>{{$t('managermentTrending.facebookName')}}</th>
              <th>{{$t('managermentTrending.interactionOccupies')}}</th>
              <th>{{$t('managermentTrending.posts')}}</th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                <vs-td>
                  <a target="_blank" :href=data[indextr].link style="color: #626262 !important;display:flex;"><feather-icon icon="FacebookIcon" style="width: 1.5rem;height: 1.5rem;"></feather-icon><span class="ml-2">{{data[indextr].name}}</span></a>
                </vs-td>
                <vs-td >
                  <span class="pl-6">{{data[indextr].percent}}%</span>
                </vs-td>
                <vs-td >
                  <span class="pl-6">{{data[indextr].post}}</span>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import VueApexCharts from 'vue-apexcharts'
import DateRangePicker from '@/layouts/components/vue2-daterange-picker/components/DateRangePicker.vue'
import moment from "moment";
import { de } from '@/components/datepicker/locale'

export default {
  name: 'app',
  data() {
    return {
      listWebTop:[],
      topFacebook:[],
      topicId:null,
      nameTopicTrending:null,
      showWorkChart:false,
      showWebsite: false,
      showFacebook: false,
      chartData:{},
      resultData:[],
      countData:null,
      dateRange: {
        endDate: new Date(),
        startDate: (() => {
          let date = new Date ();
          date.setDate(date.getDate() - 6);
          date.setHours(0,0,0);
          return date
        })()
      },
      topicDisplay:false,
      fontWordCloud: "Roboto-Regular\", Helvetica, Arial, sans-serif",
      showTooltip: false,
      jobSelected: null,
      JobOptions: [
        {label: 'Tất cả ngành nghề', value: null},
        {label: 'Giáo viên', value: 0},
        {label: 'Du lịch', value: 1},
        {label: 'Kế toán', value: 2},
        {label: 'Kiểm toán', value: 3},
      ],
      valueSelect: null,
      timeOptions: [
        {label: '7 ngày gần đây', value: 7},
        {label: '1 tháng gần đây', value: 30}
      ],
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
      rotate: {from: 0, to: 0, numOfOrientation: 0 },
      salesLine: {
        series: [],
        chartOptions: {
          chart: {
            stacked: true,
            animations: {
              enabled: true,
              easing: 'easeinout',
              speed: 800,
              animateGradually: {
                enabled: true,
                delay: 150
              },
              dynamicAnimation: {
                enabled: true,
                speed: 350
              }
            },
            toolbar: {show: false},
            dropShadow: {
              enabled: true,
              top: 20,
              left: 2,
              blur: 6,
              opacity: 0.20
            }
          },
          stroke: {
            curve: 'smooth',
            width: 4,
          },
          grid: {
            borderColor: '#ebebeb',
            xaxis: {
              lines: {
                show: true
              }
            },
            yaxis: {
              lines: {
                show: false
              }
            }
          },
          legend: {
            position: 'top',
            show: true,
          },
          colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'dark',
              inverseColors: true,
              gradientToColors: ['rgb(43, 218, 199)'],
              shadeIntensity: 1,
              type: 'horizontal',
              opacityFrom: [0.65, 0.75],
              opacityTo: [0.8, 1],
              stops: [0, 100, 100, 100],
              pattern:{
                style:'verticalLines',
                width:10,
                height:10,
                strokeWidth:10
              },
            },
          },
          markers: {
            size: 0,
            hover: {
              size: 5
            }
          },
          xaxis: {
            labels: {
              formatter: function (val) {
                if (!val) return val;

                let dateSplit = val.split('-'),
                  type = dateSplit[1],
                  dateTemp = moment(dateSplit[0], "YYYYMMDD");

                if(type === "W")
                  return `Tuần ${dateTemp.week()}`;

                if(type === "M")
                  return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

                return val.slice(6, 8) + "/" + val.slice(4, 6)
              },
              style: {
                cssClass: 'text-grey fill-current',
              }
            },
            axisTicks: {
              show: false,
            },
            categories: [],
            axisBorder: {
              show: false,
            },
          },
          yaxis: {
            tickAmount: 5,
            labels: {
              style: {
                cssClass: 'text-grey fill-current',
              },
              formatter: function (val) {
                if (Number(val) === val && val % 1 !== 0) {
                  return kFormatter(val).toFixed(1);
                } else {
                  return kFormatter(val);
                }
              }
            },
            grid: {
              show: false
            }
          },
          tooltip: {
            custom: function ({dataPointIndex, w}) {
              let chart = w.globals, seriesData = chart.initialConfig.series;
              let header = `<div class="tooltip-header-topic"> ${formatterXTooltip(chart.lastXAxis.categories[dataPointIndex])} </div>`,
                body = `<div class="tooltip-body">`;

              seriesData.forEach((item) => {
                body += `<div class="tooltip-series-line-topic" style="color: #6e6b7b;">
                            <span class="tooltip-series-name-topic">${item.name}:</span>
                            <span>${kFormatter(item.data[dataPointIndex])}</span>
                           </div>`;
              });

              body += "</div>";

              return `${header}${body}`;
            },
            enabled: true
          }
        }
      },
      totalMentioned: "",
      percentMentioned: null,
      increaseMentioned: false,

      totalDiscuss: "",
      percentDiscuss: null,
      increaseDiscuss: false,
      mention: {},
      totalPost:"",
      sharePost:"",
    }
  },
  components: {
    VuePerfectScrollbar,
    vSelect,
    VueApexCharts,
    DateRangePicker
  },
  computed: {
    validateForm: function () {
      return !this.errors.any();
    },
    timeSelect: {
      get() {
        let object = this.timeOptions.find(el => el.value === this.valueSelect);
        if (!object) {
          return {
            label: this.timeOptions[0].label,
            value: this.timeOptions[0].value
          }
        }
        return {
          label: object.label,
          value: this.valueSelect
        }
      },
      set(val) {
        this.valueSelect = val.value;
      }
    },
    jobSelect: {
      get() {
        let object = this.JobOptions.find(el => el.value === this.jobSelected);
        if (!object) {
          return null;
        }
        return {
          label: object.label,
          value: this.jobSelected
        }
      },
      set(val) {
        this.jobSelected = val.value;
      }
    },
  },
  mounted(){
  },
  async created() {
    this.id = this.$route.query.id;
    this.dateRange.startDate = new Date(this.$route.query.startDate);
    this.dateRange.endDate = new Date(this.$route.query.endDate);
    if (this.id) {
      this.$processor.post(`topic-trending/find-all-trending`,this.dateRange).then(response =>{
        this.resultData=response.data.filter(el=>el.topicId==this.id);
        this.topicId= this.resultData[0].topicId;
        this.topicDisplay=true;
        this.$vs.loading.close();
        if (this.topicId){
          this.initScreen();
        }

      }).catch(()=>{

      })

    }
  },
  methods: {
    styleTooltip(){
      document.getElementsByClassName('vs-tooltip')[0].style.setProperty('font-size','22px','important');
    },
    getTopWeb(){
      let payload={
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        topicId: this.id
      };
      this.$processor.post(`/topic-trending/get-top-website`,payload).then((res)=>{
        this.listWebTop = res.data;
        this.listWebTop = this.listWebTop.map(el=>{
          let obj={}
          obj['percent']=((el.totalData/ el.totalSource )*100).toFixed(2);
          obj['link'] = el.url;
          obj['name'] = el.name;
          obj['post'] = el.totalData;
          return obj;
        })
        this.showWebsite = true;
      })
    },
    getTopFace(){
      let payload={
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        topicId: this.id
      };
      this.$processor.post(`/topic-trending/get-top-facebook`,payload).then((res)=>{
        this.topFacebook = res.data;
        this.topFacebook = this.topFacebook.map(el=>{
          let obj={}
          obj['percent']=((el.totalData/ el.totalSource )*100).toFixed(2);
          obj['link'] = el.url;
          obj['name'] = el.name;
          obj['post'] = el.totalData;
          return obj;
        })
        this.showFacebook = true;
      })
    },
    formatDate(val) {
      return moment(val).format("DD/MM/YYYY");
    },
    optimizedChart: function (data){
      data = data.sort(function(a,b){
        return parseInt(a.stringDate) - parseInt(b.stringDate)
      })
      data.map(item => {
        let date = moment(item.stringDate, 'YYYYMMDD');
        item.month = date.format('Y') + date.format('M');
        item.week = date.week();
        item.day = date.format('D');
        return item;
      })

      let result = [];
      data.reduce(function(res, value) {
        if(data.length <= 21) {
          if (!res[value.day]) {
            res[value.day] = {day: value.day, stringDate: value.stringDate, totalData: 0};
            result.push(res[value.day])
          }
          res[value.day].totalData += value.totalData;
          res[value.day].stringDate += "-D";
          return res;
        }
        if( 14 < data.length && data.length < 62){
          if (!res[value.week]) {
            res[value.week] = {week: value.week, stringDate: value.stringDate, totalData: 0};
            result.push(res[value.week])
          }
          res[value.week].totalData += value.totalData;
          res[value.week].stringDate += "-W";
          return res;
        }
        else if(data.length > 62){
          if (!res[value.month]) {
            res[value.month] = {month: value.month, stringDate: value.stringDate, totalData: 0};
            result.push(res[value.month])
          }
          res[value.month].totalData += value.totalData;
          res[value.month].stringDate += "-M";
          return res;
        }
      }, {});
      data = result;
      return data;

    },
    initScreen(){
      this.$vs.loading();
      this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
      this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
      this.from = this.dateRange.startDate
      this.to = this.dateRange.endDate
      this.find_topics();
      this.refreshData();
    },
    refreshData: function (){
      let conditions = {
        to: this.to,
        from: this.from,
        topicId: this.id,
      };
      this.getDataWorkChart(conditions);
      this.getMention(conditions);
      this.getDataReactionChart(conditions);
      this.getTopWeb();
      this.getTopFace();
    },

    getDataWorkChart(conditions){
      this.showWorkChart = false;
      let that=this;
      this.$processor.post(`/user-data/get-work-by-day`,conditions)
        .then(res=>{
          res.data.mentionByDays = this.optimizedChart(res.data.mentionByDays);
          res.data.commentByDays = this.optimizedChart(res.data.commentByDays);
          res.data.shareByDays = this.optimizedChart(res.data.shareByDays);
          that.chartData=res.data;
          let mentionByDays={
            name:'Số lượng đề cập',
            data:that.chartData.mentionByDays.map(x=>{
              return x.totalData;
            })
          };
          let commentByDays = {
            name: this.$t('title.comment'),
            data: that.chartData.commentByDays.map(x => {
              return x.totalData;
            })
          };
          let shareByDays = {
            name: this.$t('title.share'),
            data: that.chartData.shareByDays.map(x => {
              return x.totalData;
            })
          };
          that.salesLine.series=[];
          that.salesLine.chartOptions.xaxis.categories=[];
          that.salesLine.chartOptions.xaxis.categories.push(
            ...that.chartData.mentionByDays.map(x=>{
              return x.stringDate
            })
          );
          that.salesLine.series.push(mentionByDays);
          that.showWorkChart = true;
          that.$vs.loading.close();
        })
    },
    getMention(conditions) {
      this.$processor
        .post("/user-data/get-mention", conditions)
        .then(mention => {
          this.mention = mention.data;
          this.percentMentioned = null;
          if (this.mention.countAllTo || this.mention.countAllFrom) {
            if (this.mention.countAllTo > this.mention.countAllFrom) {
              this.increaseMentioned = true;
              this.percentMentioned =
                "+" +
                (
                  ((this.mention.countAllTo - this.mention.countAllFrom) /
                    (this.mention.countAllFrom != 0
                      ? this.mention.countAllFrom
                      : 1)) *
                  100
                ).toFixed(2);
            } else {
              this.percentMentioned =
                "-" +
                (
                  ((this.mention.countAllFrom - this.mention.countAllTo) /
                    (this.mention.countAllTo != 0
                      ? this.mention.countAllTo
                      : 1)) *
                  100
                ).toFixed(2);
            }
          }
          if (this.to.getDate() == this.from.getDate())
            this.percentMentioned = null;

          //Thao luan
          this.totalDiscuss = this.mention.totalComment;
          this.percentDiscuss = null;
          if (this.mention.totalCommentTo || this.mention.totalCommentFrom) {
            if (this.mention.totalCommentTo > this.mention.totalCommentFrom) {
              this.increaseDiscuss = true;
              this.percentDiscuss =
                "+" +
                (
                  ((this.mention.totalCommentTo -
                    this.mention.totalCommentFrom) /
                    (this.mention.totalCommentFrom != 0
                      ? this.mention.totalCommentFrom
                      : 1)) *
                  100
                ).toFixed(2);
            } else {
              this.percentDiscuss =
                "-" +
                (
                  ((this.mention.totalCommentFrom -
                    this.mention.totalCommentTo) /
                    (this.mention.totalCommentTo != 0
                      ? this.mention.totalCommentTo
                      : 1)) *
                  100
                ).toFixed(2);
            }
          }
          if (this.to.getDate() == this.from.getDate())
            this.percentDiscuss = null;
          this.totalPost=this.mention.totalMentioned;
          this.totalMentioned=this.totalDiscuss+this.totalPost;
          this.$vs.loading.close();
        });
    },
    getDataReactionChart(conditions) {
      let that = this;
      this.$processor
        .post("/user-data/get-reaction-by-day", conditions)
        .then(res => {
          that.reactionChartData = res.data;
          let likes = {
            name: "Like",
            data: that.reactionChartData.likes.map(x => {
              return x.totalData;
            })
          };
          let loves = {
            name: "Love",
            data: that.reactionChartData.loves.map(x => {
              return x.totalData;
            })
          };
          let hahas = {
            name: "Haha",
            data: that.reactionChartData.hahas.map(x => {
              return x.totalData;
            })
          };
          let angrys = {
            name: "Angry",
            data: that.reactionChartData.angrys.map(x => {
              return x.totalData;
            })
          };
          let cares = {
            name: "Care",
            data: that.reactionChartData.cares.map(x => {
              return x.totalData;
            })
          };
          let sads = {
            name: "Sad",
            data: that.reactionChartData.sads.map(x => {
              return x.totalData;
            })
          };
          let wows = {
            name: "Wow",
            data: that.reactionChartData.wows.map(x => {
              return x.totalData;
            })
          };
          let array = [...likes.data,...loves.data,...hahas.data,...angrys.data,...cares.data,...sads.data,...wows.data];
          let total=(accumulator, currentValue) => accumulator + currentValue;
          this.sharePost=array.reduce(total);
        });
    },
    find_topics: function(){
      this.$processor.post(`topic-trending/find-all-trending`,this.dateRange).then(response =>{
        this.resultData=response.data.filter(el=>el.topicId==this.id);
      })
    },
    getMentionTopic(conditions) {
      this.$processor
        .post("/user-data/get-mention-topic", conditions)
        .then(topic => {
          topic.data = topic.data.sort(function(a, b) {
            if (a.countMention > b.countMention) return -1;
            if (a.countMention < b.countMention) return 1;
            return 0;
          });
          this.totalPost =[...topic.data.map(x => {
            return x.countMention;})];
          let total=(accumulator, currentValue) => accumulator + currentValue;
          this.totalPost=this.totalPost.reduce(total);
        });
    },
    backTrending(){
      this.$router.push('/user/social-trending');
    }
  }
}
function formatterXTooltip(strDate) {
  strDate = [strDate.slice(0, 4), "-", strDate.slice(4,8)].join('');
  strDate = [strDate.slice(0, 7), "-", strDate.slice(7)].join('');
  let newDate = new Date(strDate);
  if(isNaN(newDate.getTime())) return "";

  let day = newDate.getDay() === 0 ? "Chủ nhật" : `Thứ ${newDate.getDay() + 1}`;

  return day + ", " + newDate.getDate() + "/" + (newDate.getMonth() + 1) + "/" + newDate.getFullYear();
}
function formatterDate(val){
  if (!val) return val;

  let dateSplit = val.split('-'),
    type = dateSplit[1],
    dateTemp = moment(dateSplit[0], "YYYYMMDD");

  if(type === "W")
    return `Tuần ${dateTemp.week()}`;

  if(type === "M")
    return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

  return val.slice(6, 8) + "/" + val.slice(4, 6)
}
function kFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
  }
  return num;
}
function groupByKey(array, key) {
  return Object.values( array
    .reduce((hash, obj) => {
      if(obj[key] === undefined) return hash;
      return Object.assign(hash, { [obj[key]]:( hash[obj[key]] || [] ).concat(obj)})
    }, {}))
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxCard.scss";
.apexcharts-xaxistooltip {
  opacity: 0;
  padding: 9px 10px;
  pointer-events: none;
  color: #373d3f;
  font-size: 13px;
  text-align: center;
  border-radius: 2px;
  position: absolute;
  z-index: 10;
  background: #ECEFF1;
  border:none;
  transition: 0.15s ease all;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;

  padding-left: 25px;
}
.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, .5, .5, 1) infinite
}
.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -.24s
}
.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -.12s
}
.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px
  }

  50%, 100% {
    top: 16px;
    height: 4px
  }
}

.text-grey{
  color: #626262;
}
.tooltip-series-name-topic{
  margin: 5px 8px;
  font-family: Montserrat,Helvetica,Arial,serif!important;
  fill: #6e6b7b;
  font-weight: 400;
  -webkit-filter: none;
}
.tooltip-series-line-topic {
  color: #626262;
  padding: 5px 15px 5px 10px;
}
.tooltip-header-topic {
  color: #626262;
  padding: 7px 20px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.title{
  font-size: 20px;
  color: #626262;
  font-weight: 500;
}
.title-page{
  cursor: pointer;
  font-size: 2.2rem;
  font-weight: bold;
  display: flex;
}
.reportrange-text{
  border-radius: 10px;
}
.source-trending{
  padding-left: 24px !important;
}
.source-trending .row {
  border-bottom: 1px solid #f7f7f8;
  padding: 16px 0px;
  height: 50px;
}
#demo-basic-card {
  .card-view {
    background: #fff;
    border-radius: 10px;
    padding: 5px 10px 10px 10px;
    box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 0.1);
    -webkit-transition: all 0.3s ease-in-out;
    margin-top: -20px;
    margin-bottom: 30px;
  }

  .card-view-xhh {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    box-shadow: 0px 4px 25px 0px rgba(95, 94, 94, 0.1);
    margin-bottom: 10px;
  }

  .xh {
    border-bottom: 1px solid #cccccc;
  }
  .wordCloud {
    .text {
      cursor: pointer;
    }
  }
  .trending-choose{
    display: flex;
    margin-bottom: 24px;
    border-bottom: 1px solid #eaecef;
    padding: 24px 0px;
  }
  .name-trending{
    font-size: 22px;
    font-style: normal;
    font-weight: bold;
    letter-spacing: 1px;
    line-height: 45px;
    color: #FEC75E;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical;
  }
  .number {
    margin: 8px 0px;
    color: #626262;
    font-family: HKGrotesk;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    text-transform: uppercase;
  }
  .widthTopic{
    width: 300px;
  }
}
.sizeIcon{
  transform: scale(0.8);
}
.text-icon{
  color: #626262;
}
.vs-table--tbody{
  z-index: 1;
}
.vs-con-tbody .vs-table--tbody {
  z-index:0
}
</style>
